import moment from 'moment';
import { hyperdbTriggers } from 'hyperdb-utils';
import httpRequest from '../../../helpers/httpRequest';
import * as config from '../../../../config';

const triggers = hyperdbTriggers({ config,
  triggerName: 'reservation',
  namespace: 'RESERVATION',
  entryPoint: '/reservations',
  collectionName: 'reservations',
  querySearchListing: [
    [
      'reference', 'creation_date', 'status', 'deposit_paid', 'amount_paid', 'arrival_date', 'departure_date', 'origin',
      ['customer', ['name'] ],
      ['property', ['name'] ],
    ],
  ],
  quickSearch: (keyword) => {
    return { $any: [
      { reference: { match: keyword } },
      { 'customer.name': { match: keyword } },
      { 'customer.entity.primary_email': { match: keyword } },
    ] };
  },
  filters: {
    new: () => ({ status: 'new' }),
    requested: () => ({ status: 'requested' }),
    offered: () => ({ status: 'offered' }),
    accepted: () => ({ status: 'accepted' }),
    recent_prereservations: () => {
      const limitDate = moment().subtract(2, 'days').format('YYYY-MM-DD');
      return { status: 'accepted', creation_date: { gte: limitDate }, $any: [{ deposit_paid: false }, { deposit_paid: { eq: null } }] };
    },
    earlier_prereservations: () => {
      const limitDate = moment().subtract(2, 'days').format('YYYY-MM-DD');
      return { status: 'accepted', creation_date: { lt: limitDate }, $any: [{ deposit_paid: false }, { deposit_paid: { eq: null } }] };
    },
    to_validate: () => ({ status: 'accepted', deposit_paid: true }),
    confirmed: () => ({ status: 'confirmed' }),
    not_printed: () => ({ status: 'confirmed', $any: [{ confirmation_printed: false }, { confirmation_printed: { eq: null } }] }),
    rejected: () => ({ status: 'rejected' }),
    aborted: () => ({ status: 'aborted' }),
    canceled: () => ({ status: 'canceled' }),
    error: () => ({ $all: [{ error_code: { ne: null } }, { error_code: { gt: 0 } }] } ),
  },
  successMessageCreate: 'Reservation created',
  successMessageUpdate: 'Reservation updated',
  successMessageDelete: 'Reservation deleted',
});

export default {
  ...triggers,
  sendEmail(dispatch, getState, { id, message }) {
    const url = config.APP_URL + `/reservations/${id}/send-email`;
    return doItemAction(dispatch, getState, { id, message, url });
  },
  accept(dispatch, getState, { id, message }) {
    const url = config.APP_URL + `/reservations/${id}/accept`;
    return doItemAction(dispatch, getState, { id, message, url });
  },
  offer(dispatch, getState, { id, message }) {
    const url = config.APP_URL + `/reservations/${id}/offer`;
    return doItemAction(dispatch, getState, { id, message, url });
  },
  reject(dispatch, getState, { id, message }) {
    const url = config.APP_URL + `/reservations/${id}/reject`;
    return doItemAction(dispatch, getState, { id, message, url });
  },
  notifyUnavailable(dispatch, getState, { id, message }) {
    const url = config.APP_URL + `/reservations/${id}/notify-unavailable`;
    return doItemAction(dispatch, getState, { id, message, url });
  },
  abort(dispatch, getState, { id, message }) {
    const url = config.APP_URL + `/reservations/${id}/abort`;
    return doItemAction(dispatch, getState, { id, message, url });
  },
  confirm(dispatch, getState, { id, message }) {
    const url = config.APP_URL + `/reservations/${id}/confirm`;
    return doItemAction(dispatch, getState, { id, message, url });
  },
  resend_prebooking_email(dispatch, getState, { id }) {
    const url = config.APP_URL + `/reservations/${id}/resend-prebooking-email`;
    return doItemAction(dispatch, getState, { id, url });
  },
  cancel(dispatch, getState, { id, message }) {
    const url = config.APP_URL + `/reservations/${id}/cancel`;
    return doItemAction(dispatch, getState, { id, message, url });
  },
  reactivate(dispatch, getState, { id }) {
    const url = config.APP_URL + `/reservations/${id}/re-activate`;
    return doItemAction(dispatch, getState, { id, url });
  },
  removeError(dispatch, getState, { id }) {
    const url = config.APP_URL + `/reservations/${id}/remove-error`;
    return doItemAction(dispatch, getState, { id, url });
  },
};

function doItemAction(dispatch, getState, params) {
  const { id, url, message, ...otherParams } = params;
  dispatch({ type: 'RESERVATION__POST_DATA' });
  const data = message ? { message: { ...message, id: 0 } } : {};
  return httpRequest('POST', params.url, { ...data, ...otherParams })
    .then(res => {
      dispatch({ type: 'RESERVATION__POST_DATA_SUCCESS' });
      dispatch({ type: 'RESERVATION__SET_DATA', payload: { actionSuccessful: true} });
      return res;
    })
    .catch(err => {
      dispatch({ type: 'RESERVATION__ERROR', payload: err });
    });
}



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/reservation/triggers.js